import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';

import { Observable } from 'rxjs';

import {
    ScriptLoaderService, ClassService
} from '../../../../../_services';
import { Investor } from '../../../../../_models';

@Component({
    selector: 'app-investor-contact',
    templateUrl: './investor-contact.component.html',
    styleUrls: ['./investor-contact.component.scss']
})
export class InvestorContactComponent implements OnInit, AfterViewInit {
    static initialClass: string =
    'm-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    form: FormGroup;
    investorId: number;
    contactId: number;
    contactHeader = {
        icon: 'fa fa-id-card',
        text: 'Agregar contacto'
    }
    saveRequest$: Observable<Object>;
    constructor(private _script: ScriptLoaderService, private _location: Location, fb: FormBuilder,
        private _classService: ClassService,
        private route: ActivatedRoute, private router: Router,
        private data: Investor
    ) {
        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required])],
            'email': ['', Validators.compose([Validators.required])],
            'telephone': ['', Validators.compose([Validators.required])],
            'mobile': ['', Validators.compose([Validators.required])],
            'role': ['', Validators.compose([Validators.required])],
            'default': [false, Validators.compose([Validators.required])],
        });
        this.form.valueChanges.subscribe(formValue => {
            this.saveRequest$ =
                (this.contactId) ?
                    this.data.updateContact(this.investorId, this.contactId, formValue) :
                    this.data.postContact(this.investorId, formValue);
        });
    }

    ngOnInit() {
        this.investorId = this.route.snapshot.params['id'];
        this.contactId = this.route.snapshot.params['contactId'];

        if (this.contactId) {
            this.data.getContact(this.investorId, this.contactId).subscribe(data => {
                console.log(data);
                this.form.setValue(data.pick(this.form.value));
            });
        }
    }

    ngAfterViewInit() {
        this._script.loadScripts('app-investor-address',
            ['assets/app/js/investor.js']);
        this._classService.setClass(document.body, InvestorContactComponent.initialClass);
    }

    back() {
        this._location.back();
    }
    error(error) {
        console.error(error);
    }
    end() {
        this.router.navigate([`/investors/${this.investorId}`]);
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-contact/investor-contact.component.ts